import _ from "lodash"
import api from "../api"

const getNextStep = (currentStep, offset = 1, iteration = 0) => {
  if (iteration > 120) return false
  let nextStepOrder = currentStep.SortOrder + offset
  let steps         = api.order.Steps // important. Don't get filtered steps by getSteps()
  let nextStep      = steps.filter(step => {
    return step.SortOrder === nextStepOrder
  })

  let step = _.first(nextStep)
  if (step && (step.TypeCode === "Group" || step.TypeCode === "Material" || step.TrackingId === api.TRACK_ID_EXTRA_SIGNATURE)) return getNextStep(step, offset, iteration++)
  return step
}

const getPreviousStep = (currentStep) => {
  return getNextStep(currentStep, -1)
}

export default getNextStep
export {getPreviousStep}



// WEBPACK FOOTER //
// ./src/util/getNextStep.js